// shared logic between MoveComined/mobile.vue & Disclaimer/desktop.vue
import { object } from 'yup';
import {
  mapErrors,
  objectIsValid,
} from '@mgo/core/src/validations/utils';
import { attachFieldErrors } from '@mgo/core/src/validations/stringValidator';
import Cookies from 'js-cookie';
import { isUspsProd, isUspsProdInternal } from '@mgo/core/src/environment';
import pageView from '../../mixins/pageView';
import validators from '../VerifyInfoEdit/validations';
import { redirectToHomePage } from '../../utils/commonUtil';

/**
 * Maps a boolean field from api response, to a radio value
 * @param {Boolean} value
 * @param {String}
 */
const mapBooleanToRadios = (value) => (value ? 'YES' : 'NO');

export default {
  mixins: [pageView],
  filters: {
    exceptionNextToSave(str) {
      return str.replace(/Next/g, 'Save');
    },
  },
  data() {
    return {
      fieldErrors: [],
      improvedFieldErrors: {},
      hidePrivacyActContent: true,
      showBusinessAlias: false,
      lazy: true,
      medUpdated: false, // start date updated
      sdUpdated: false, // stop date updated
      cfpsid: Cookies.get('coa_complete') || '',

      // coa
      dcoa: false,
      informedDelivery: false,
      businessName: '',
      businessAliases: [],
      businessAlias1: '',
      businessAlias2: '',
      businessAlias3: '',
      businessAlias4: '',
      startDate: '',
      stopDate: '',
      moverType: '',
      forwardType: '',
      billingAddressType: '',

      // mover
      firstName: '',
      middleName: '',
      lastName: '',
      suffix: '',
      email: '',
      emailConfirm: '',
      phoneNumber: '',
      phoneType: 'MOBILE',

      // address
      oldStreetAddress: '',
      oldCity: '',
      oldState: '',
      oldZipCode: '',
      oldUrbanizationName: '',
      oldPoBoxNumber: '',
      oldAddressUUID: '',
      newStreetAddress: '',
      newCity: '',
      newState: '',
      newZipCode: '',
      newUrbanizationName: '',
      newPoBoxNumber: '',
      newPrivateMailbox: '',
      newAddressUUID: '',
      recentConstruction: false,
      overrideAms: false,
      billingAddressUUID: '',

      // coaCheck modal
      coaCheckModal: false,

      primaryBusiness: false,
      optInMailReminder: false,
    };
  },
  computed: {
    twoFactorAuthEnabled() {
      return (this.moverType !== 'BUSINESS' && this.$store.get('config@twoFactorAuthEnabled'));
    },
    informedDeliveryEligible() {
      return (
        this.moverType
        && this.moverType !== 'BUSINESS'
        && this.forwardType === 'PERMANENT'
        && this.billingAddressType !== 'OTHER'
      );
    },
    isProduction() {
      return isUspsProd(window.location.href) || isUspsProdInternal(window.location.href);
    },
    rules() {
      return object().shape(validators);
    },
    errors() {
      const fieldsToValidate = [
        'moverType',
        'email',
        'emailConfirm',
        'phoneNumber',
        'phoneType',
        'forwardType',
        /* 'oldZipCode',
        'oldCity',
        'oldState',
        'oldStreetAddress',
        'newZipCode',
        'newCity',
        'newState',
        'newStreetAddress', */
        'startDate',
      ];

      if (this.forwardType === 'TEMPORARY') fieldsToValidate.push('stopDate');

      if (this.moverType !== 'BUSINESS') {
        fieldsToValidate.push('firstName');
        fieldsToValidate.push('lastName');
      }

      if (this.moverType !== 'BUSINESS' && this.middleName) {
        fieldsToValidate.push('middleName');
      }

      if (this.showOldPoBox) {
        fieldsToValidate.push('oldPoBoxNumber');
      }

      if (this.oldState === 'PR') {
        fieldsToValidate.push('oldUrbanizationName');
      }

      if (this.showNewPrivateMailbox) {
        fieldsToValidate.push('newPrivateMailbox');
      }

      if (this.showNewPoBox) {
        fieldsToValidate.push('newPoBoxNumber');
      }

      if (this.newState === 'PR') {
        fieldsToValidate.push('newUrbanizationName');
      }

      if (this.moverType === 'FAMILY') {
        fieldsToValidate.push('familySameLastName');
        fieldsToValidate.push('familyRemaining');
      }

      if (this.moverType === 'BUSINESS') {
        fieldsToValidate.push('businessWholeCompany');
        fieldsToValidate.push('businessName');
      }

      if (this.flagBusinessAliasEnabled && this.moverType === 'BUSINESS'
      && !this.enhancedBusinessAliasesEnabled) {
        fieldsToValidate.push('businessAlias1');
        fieldsToValidate.push('businessAlias2');
        fieldsToValidate.push('businessAlias3');
        fieldsToValidate.push('businessAlias4');
      }

      if (this.renderV3Challenge) {
        fieldsToValidate.push('recaptchaChallengeToken');
      }

      return { ...mapErrors(this, fieldsToValidate), ...this.improvedFieldErrors };
    },
    businessAliasValid() {
      return this.flagBusinessAliasEnabled && this.moverType === 'BUSINESS' && this.showBusinessAlias
        ? this.$refs.businessAliases?.isValid() : true;
    },
    formIsValid() {
      if (this.enhancedBusinessAliasesEnabled) {
        // Need to call extended validation for multi business alias component
        return objectIsValid(this.errors) && this.businessAliasValid;
      }
      return objectIsValid(this.errors);
    },
    flagBusinessAliasEnabled() {
      return this.$store.get('flagBusinessAliasEnabled');
    },
    enhancedBusinessAliasesEnabled() {
      return this.$store.get('config@enhancedBusinessAliasesEnabled');
    },
    enhancedBusinessAliasesIncrementCount() {
      return this.$store.get('config@enhancedBusinessAliasesIncrementCount');
    },
    enhancedBusinessAliasesInitialCount() {
      return this.$store.get('config@enhancedBusinessAliasesInitialCount');
    },
    enhancedBusinessAliasesMaxCount() {
      return this.$store.get('config@enhancedBusinessAliasesMaxCount');
    },
  },
  watch: {
    forwardType(currentValue) {
      if (currentValue === 'TEMPORARY' && this.primaryBusiness) {
        sessionStorage.removeItem('extension');
        sessionStorage.removeItem('extensionSelected');
        sessionStorage.setItem('informedDeliveryEligible', false);
        sessionStorage.removeItem('informedDelivery');
      }
    },
    moverType(currentValue) {
      if (currentValue !== 'BUSINESS') {
        this.showBusinessAlias = false;
      }
    },
    oldAddressString(newValue, oldValue) {
      if (oldValue.length && newValue !== oldValue && !this.oldPoBoxException) {
        this.oldAddressError = '';
      }
    },
    newAddressString(newValue, oldValue) {
      if (oldValue.length && newValue !== oldValue) {
        this.newAddressError = '';
        this.recentConstruction = false;
        this.overrideAms = false;
        this.newConstructionResetAttempts();
      }

      if (oldValue.length && newValue !== oldValue && !this.newPoBoxException) {
        this.newAddressError = '';
      }
    },
  },
  async mounted() {
    if (!this.$coa.coaUUID) {
      redirectToHomePage(this);
      return;
    }
    // enable loader for redirect
    this.$store.commit('ENABLE_LOADER');

    const selectCOAUuid = await this.hydrateCOA();
    this.optInMailReminder = JSON.parse(sessionStorage.getItem('optInMailReminder') ?? false);

    // redirect to disclaimer if insufficient coa data or coa already completed
    if (!this.startDate || this.cfpsid) {
      this.$router.push({ name: 'disclaimer' });
      this.$store.commit('DISABLE_LOADER');
      return;
    }

    await this.hydrateMover(selectCOAUuid);

    this.$store.commit('DISABLE_LOADER');

    this.pageView();
  },
  methods: {
    async validate() {
      this.oldAddressError = '';
      this.newAddressError = '';
      this.improvedFieldErrors = {};
      this.fieldErrors = [];
      this.lazy = false;
      await this.$nextTick();
      if (!this.formIsValid) return this.scrollToFirstError();
      return this.submit();
    },
    attachFieldErrors,
    async scrollToFirstError() {
      const errorHTML = document.querySelector('.errors');
      if (errorHTML !== null) {
        setTimeout(() => {
          errorHTML.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    },
    setPrimaryBusiness(value) {
      this.primaryBusiness = value;
    },
    async hydrateCOA() {
      const business = await this.$coa.businessGetAll();
      const curBusiness = business && business.length
                              && business.filter((v) => v.uuid === this.$route.params.orderUuid);

      const { uuid, ...coa } = curBusiness.length && curBusiness[0];
      if (uuid) {
        this.billingAddressType = coa.billingAddressType;
        this.businessName = coa.businessName;
        this.dcoa = coa.dcoa;
        this.informedDelivery = coa.informedDelivery;
        this.forwardType = coa.forwardType;
        this.moverType = coa.moverType;
        this.startDate = coa.startDate;
        this.stopDate = coa.stopDate;
      }
      if (coa.moverType === 'FAMILY') {
        this.familySameLastName = coa.famPrompt1ShareLastName !== null
          ? mapBooleanToRadios(coa.famPrompt1ShareLastName)
          : '';
        this.familyRemaining = coa.famPrompt2SameLastNameRemaining !== null
          ? mapBooleanToRadios(coa.famPrompt2SameLastNameRemaining)
          : '';
      }

      if (coa.moverType === 'BUSINESS') {
        this.businessWholeCompany = coa.bizPromptEntireMoving !== null
          ? mapBooleanToRadios(coa.bizPromptEntireMoving)
          : '';
        const { aliases } = this.flagBusinessAliasEnabled && uuid
             ? await this.$coa.businessAliasGetAllByOrderUuid(uuid)
             : {};
        if (aliases?.length) {
          // open businessAlias dropdown
          this.showBusinessAlias = true;

          if (this.enhancedBusinessAliasesEnabled) {
            this.businessAliases = aliases;
          } else {
            this.businessAlias1 = 0 in aliases ? aliases[0].value : '';
            this.businessAlias2 = 1 in aliases ? aliases[1].value : '';
            this.businessAlias3 = 2 in aliases ? aliases[2].value : '';
            this.businessAlias4 = 3 in aliases ? aliases[3].value : '';
          }
        }
      }
      return uuid;
    },
    async hydrateMover(uuid) {
      const { MOVER } = await this.$coa.personGetAllByUuid(uuid);
      if (MOVER) {
        this.firstName = MOVER.firstName;
        this.middleName = MOVER.middleName;
        this.lastName = MOVER.lastName;
        this.suffix = MOVER.suffix;
        this.email = MOVER.email;
        this.emailConfirm = MOVER.email;
        this.phoneNumber = MOVER.mobilePhone || MOVER.homePhone;
        this.phoneType = MOVER.mobilePhone ? 'MOBILE' : 'HOME';
      }
    },
    disableMoverType(value) {
      if (value) {
        this.disableNonBusinessMover = true;
      } else {
        this.disableNonBusinessMover = false;
      }
    },

    /**
     * @param {*} query query object for the Vue Router
     */
    async next(query = {}, exception) {
      await this.$nextTick();
      // If there are logged errors
      // prevent the next step
      if (this.oldAddressError
        || this.newAddressError
        || this.fieldErrors.length
        || exception) {
        this.$store.commit('DISABLE_LOADER');
        this.scrollToFirstError();
        return;
      }
      sessionStorage.setItem('sdUpdated', this.sdUpdated);
      sessionStorage.setItem('medUpdated', this.medUpdated);
      // add start date updated to query params
      if (this.medUpdated) {
        Object.assign(query, { medUpdated: this.medUpdated });
      }

      // add stop date updated to query params
      if (this.sdUpdated) {
        Object.assign(query, { sdUpdated: this.sdUpdated });
      }

      this.$router.push({ name: 'verify-info-read', query });
    },
    prepareFieldErrors(resp) {
      if (!resp) return null;
      const { raw, xhr } = resp;
      if (!raw && !xhr) return null;
      const obj = xhr.fieldErrors.reduce((accum, { field, message }) => {
        if (field === 'mobilePhone' || field === 'homePhone') {
          Object.assign(accum, { phoneNumber: { message, hasError: true } });
        } else {
          Object.assign(accum, { [field]: { hasError: true, message } });
        }
        return accum;
      }, {});
      this.improvedFieldErrors = { ...this.improvedFieldErrors, ...obj };
      return this.improvedFieldErrors;
    },
    async validateForm() {
      // toggle of lazy flag required to force validation anytime this method gets called
      this.lazy = true;
      this.lazy = false;

      if (!this.formIsValid) {
        this.$nextTick(() => {
          this.scrollToFirstError();
        });
      }
    },
    updateFieldErrors(fieldErrors) {
      this.attachFieldErrors(fieldErrors);
      this.prepareFieldErrors(fieldErrors);
    },
    updateFieldErrorsMilitary(error) {
      this.fieldErrors = [
        ...this.fieldErrors,
        { field: error.field, message: error.message },
      ];
      this.errors[error.field].hasError = true;
      this.errors[error.field].message = error.message;
    },
    moreAlias() {
      const bAliases = this.$refs.businessAliases;
      bAliases.moreAlias();
      bAliases.focus();
    },
  },
};
